import styled from 'styled-components';

// Components
import { ToastShell, ToastText } from '../shared/styles';

/**
 * Caja común (ver `../shared/styles.ts`); aquí solo el borde que lo distingue.
 *
 * Este toast ya crecía con su contenido: era el ÚNICO de los cuatro que lo
 * hacía, y su solución es la que se promovió a caja común.
 */
export const Container = styled(ToastShell)`
  border: 1px solid ${({ theme }) => theme.colors.red};
`;

export const IconError = styled.div`
  width: 2.4rem;
  height: 2.4rem;
  flex-shrink: 0;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.red};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.white};
  font-weight: bold;
  font-size: 1.6rem;
`;

export const Text = styled(ToastText)`
  margin-left: 1.2rem;
  color: ${({ theme }) => theme.colors.red};
`;
